<app-link-column [label]="label()" [routerLink]="routerLink()"></app-link-column>
